import { render, staticRenderFns } from "./PropertyBoolean.vue?vue&type=template&id=08731cf0&scoped=true"
import script from "./PropertyBoolean.vue?vue&type=script&lang=ts"
export * from "./PropertyBoolean.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08731cf0",
  null
  
)

export default component.exports